import { armorTypes } from 'app/frontend/types/custom/ArmorType'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { CharacterClassIcon } from 'app/frontend/base/components'
import { CharacterClass } from 'app/frontend/types/custom'
import StatTable from './StatTable'
import BlizzardIcon from 'app/frontend/base/components/BlizzardIcon'

const ArmorTypes = () => {
  const armorTypeIcons: Record<string, string> = {
    Cloth: 'inv_chest_cloth_21',
    Leather: 'inv_chest_leather_09',
    Mail: 'inv_chest_chain',
    Plate: 'inv_chest_plate05',
  }

  return (
    <StatTable<CharacterClass[]>
      title='Armor type'
      subject={armorTypes}
      memberFilterFn={(member, classes) =>
        classes.includes(member.characterReference.characterClass)
      }
      valueFn={(armorType, classes) => (
        <Tooltip>
          <TooltipTrigger>
            <span className='flex items-center gap-1.5'>
              <BlizzardIcon
                category={56}
                iconName={armorTypeIcons[armorType]}
                size='small'
              />
              {armorType}
            </span>
          </TooltipTrigger>
          <TooltipContent className='flex gap-2'>
            {classes.map((c) => (
              <CharacterClassIcon key={c} characterClass={c} size='medium' />
            ))}
          </TooltipContent>
        </Tooltip>
      )}
    />
  )
}

export default ArmorTypes
